import { useMediaQuery } from '@mui/material';
import { appTokens } from '../theme/tokens';

export const useDeviceDetection = () => {
	const isDesktop = useMediaQuery(
		`(min-width:${ appTokens.breakpoints.desktop })`
	);
	const isPhone = useMediaQuery( `(max-width:${ appTokens.breakpoints.phone })` );

	const isTablet = useMediaQuery(
		`(min-width:${ appTokens.breakpoints.phone }) and (max-width:${ appTokens.breakpoints.desktop })`
	);

	const isTouch = useMediaQuery( '(pointer: coarse)' );

	return {
		isMobile: !isDesktop,
		isDesktop,
		isTouch,
		isPhone,
		isTablet,
	};
};
